/** Matches `h-10` on the sensor pin wrapper (`map-marker.tsx`). */
export const MAP_SENSOR_MARKER_HEIGHT_PX = 40;
export const MAP_SENSOR_MARKER_POPUP_GAP_PX = 8;
/** Matches Tailwind `scale-120` on an emphasized pin. */
export const MAP_SENSOR_MARKER_EMPHASIS_SCALE = 1.2;

/** Popup offset when the marker uses `anchor: "bottom"` (tip at the coordinate). */
export const getMapSensorMarkerPopupOffset = (emphasized = false): number =>
	MAP_SENSOR_MARKER_HEIGHT_PX *
		(emphasized ? MAP_SENSOR_MARKER_EMPHASIS_SCALE : 1) +
	MAP_SENSOR_MARKER_POPUP_GAP_PX;

/** Extra pixels the popup lifts so it stays above a 1.2× pin. */
export const getMapSensorMarkerPopupEmphasisLiftPx = (): number =>
	getMapSensorMarkerPopupOffset(true) - getMapSensorMarkerPopupOffset();
